<template>
  <div class="card is-small-padding">
    <div class="card-body">
      <div class="flex mb-1">
        <img
          v-if="!isSmall"
          class="mr-2 block user-img hidden-mobile-small"
          src="@/assets/images/default-user-img.png"
          :alt=" $t('opinion.userImgThumbnail')">

        <div class="opinion-wrapper">
          <div class="flex flex-wrap full-width">
            <h2 class="heading-medium-small mr-auto">
              {{opinion.customer_name}} {{opinion.customer_surname}}
            </h2>

            <div class="ml-2 ml-0-xs mb-1-xs full-width-xs status small opinion-source">
              {{ $t('ui.source') }}:
              <template v-if="opinion.inquiry_id">
                <router-link :to="'/oferty-kredytowe/' + opinion.inquiry_id">
                  {{ $t('messagesList.numberOfOffer') }} {{ opinion.inquiry_id }}
                </router-link>

              </template>
              <template v-else>
                {{ $t('ui.website') }}
              </template>
            </div>
          </div>
          <div class="flex flex-align-items-center rating-wrapper mt-1">
            <div
              v-for="(index) of 5"
              :key="'opinion-' + index"
              :class="{
                'star-wrapper small': true,
                'is-selected': opinion.note >= index
              }">
              <f-icon
                name="star"
                class="rating-star" />
            </div>
            <span class="text-grey-light ml-1">
              {{ prepareDateString(opinion.created_at)}}
            </span>
          </div>
          <div class="opinion-description mt-1">
            {{ isSmall && isDescriptionLong && !isCollapsed ? opinion.description.slice(0, maxLength) + ' ...' :  opinion.description }}
          </div>
          <f-button
            v-if="isSmall && isDescriptionLong"
            :class="{
              'read-more ml-auto block': true,
              'read-less': isCollapsed
            }"
            theme="read-more"
            @click.prevent="toggleShowDescription">
            {{ isCollapsed ? 'Czytaj mniej' : 'Czytaj więcej' }}
          </f-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'f-opinion',
  props: {
    opinion: {
      type: Object,
      required: true
    },
    isSmall: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isCollapsed: false,
      isDescriptionLong: false,
      maxLength: 220
    }
  },
  mounted () {
    if (this.isSmall && this.opinion.description.length > this.maxLength) {
      this.isDescriptionLong = true;
    }
  },
  methods: {
    prepareDateString (date) {
      if (!date) {
        return this.$t('ui.none');
      }

      let dateObject = new Date(date);

      return [
        dateObject.getDate(),
        dateObject.getMonth() + 1,
        dateObject.getFullYear()
      ].map(n => n < 10 ? '0' + n : n).join('.');
    },
    toggleShowDescription () {
      Vue.set(this, 'isCollapsed', !this.isCollapsed);
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables.scss';
.user-img  {
  height: 58px;
  width: 58px;
}

.opinion-wrapper {
  max-width: 100%;
  width: 100%;
}

.opinion-description {
  transition: all .25s ease;
}

.opinion-source {
  margin-top: 7px;

  a {
    font-size: var(--font-size-small);
  }
}

.read-more {
  padding-right: 3px!important;
}

@media screen and (max-width: $media-tablet-xl) {
  .user-img  {
    height: 48px;
    width: 48px;
  }
}

</style>
